import { render, staticRenderFns } from "./cardOrderList.vue?vue&type=template&id=3531acde&scoped=true&"
import script from "./cardOrderList.vue?vue&type=script&lang=js&"
export * from "./cardOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3531acde",
  null
  
)

export default component.exports